import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef, useCallback  } from "react"
import CSSTransition from 'react-transition-group/CSSTransition';

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { IconButton, Radio,   } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ExclamationCircleIcon} from '@heroicons/react/24/solid';

import { CcActionButton, CcActionButtonOutlined } from "../commonComponents/styledTexts";

import axios from 'axios';

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, FileSelector, InputNumber, InputText, LionListbox, InputURL} from '../commonComponents/inputFields'


import { Icon as Iconify } from '@iconify/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaConditionsManager } from '../components/helperErrors'
import { lionIcons } from '../components/helpersIcons';

import { CloseButton, Dialog, DialogPanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import dayjs from "dayjs";
import { ccColorDarkTeal, ccColorTeal } from '../components/helpersStyles';
import { RandomId } from '../components/helpers';
import { renderCellSnippetType } from '../components/snippetsGrid';

import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


const Utils = {
   getComparisonOperatorPretty(operator) {
    switch (operator) {
      case "==":
        return "Equal to"
      case "!=":
        return "Not equal to"
      case "<":
        return "Less than"
      case ">":
        return "Greater than"
      case "<=":
        return "Less than or equal to"
      case ">=":
        return "Greater than or equal to"
      default:
        return operator
    }
  },
   getLogicOperatorPretty(operator) {
    switch (operator) {
      case "&&":
        return "AND"
      case "||":
        return "OR"
      case "!":
        return "NOT"
      default:
        return operator
    }
  },
  getComparisonOperatorsForListBox() {
    const result = []
    result.push({name: Utils.getComparisonOperatorPretty('=='), id:"=="})
    result.push({name: Utils.getComparisonOperatorPretty('!='), id:"!="})
    result.push({name: Utils.getComparisonOperatorPretty('<'), id:"<"})
    result.push({name: Utils.getComparisonOperatorPretty('>'), id:">"})
    result.push({name: Utils.getComparisonOperatorPretty('<='), id:"<="}) 
    result.push({name: Utils.getComparisonOperatorPretty('>='), id:">="})

    return result
  },
  getComparisonOperatorsStringOnlyForListBox() {
    const result = []
    result.push({name: Utils.getComparisonOperatorPretty('=='), id:"=="})
    result.push({name: Utils.getComparisonOperatorPretty('!='), id:"!="})
    return result
  },
  getDaysOfWeekForListBox() {
    const result = Array.from({ length: 7 }, (_, i) => {
      return {id: i, name: dayjs().day(i).format('dddd')}
    })
    return result
  },
  getMonthsForListBox() {
    const result = Array.from({ length: 12 }, (_, i) => {
      return {id: i+1, name: dayjs().month(i).format('MMMM')}
    })
    return result
  },
}

const AddConditionButton = (props) => {
  const [isOpen, setIsOpen] = useState(false)
  
  const BlockButton = (props) => {
      const handleClick = () => {
        const block = {blockId: RandomId(20), code: props.code, type: props.type, subtype: props.subtype, symbolPretty: props.symbolPretty}
        if (props.type.startsWith('condition.')) block.editMode = true
        if (props.onClick) props.onClick(block)
      }

      return <CloseButton onClick={handleClick}>
        <div className='flex border rounded justify-center items-center min-w-12 w-fit h-12 px-2 hover:bg-slate-300'>
          {props.symbolPretty}
      </div>
      </CloseButton>
    }

    const handleAddConditionBlock = (block) => {
      if (props.onChange) props.onChange(block)
    }

  return  <>
            {props.simple ?
              <button className="text-slate-700 text-lg border border-slate-700 rounded flex items-center justify-center hover:cursor-pointer hover:text-white hover:bg-slate-400 focus:outline-none w-16 mt-4 h-[80px]"
                onClick={() => setIsOpen(true)}>
                  <Iconify icon={lionIcons.Icon_Actions_Add} width={30} />
              </button>
              :
              <button className="text-slate-700 text-lg border border-slate-700 rounded px-4 py-1 hover:cursor-pointer hover:text-white hover:bg-slate-400 focus:outline-none"
                onClick={() => setIsOpen(true)}>
                  + Add a block
              </button>
            }
            <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
              <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel anchor={props.simple ? undefined : 'bottom'} className="flex flex-col bg-white rounded px-2 py-1 h-[460px] w-2/3 overflow-auto shadow-lg border border-slate-300">
                  <div className='text-ccColorDarkTeal'>
                      <div className='flex flex-row items-center'>
                        <div className='font-semibold font-poppins'>Parentheses</div>
                        <div className='flex grow'></div>
                        <IconButton onClick={() => setIsOpen(false)}><Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} /></IconButton>
                      </div>
                      <div className='flex flex-row items-center gap-x-2 -mt-3'>
                          <BlockButton symbolPretty="(" code="(" type="parenthesis" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty=")" code=")" type="parenthesis" onClick={handleAddConditionBlock} />
                      </div>
                      <div className='font-semibold font-poppins mt-4'>Logical Operators</div>
                      <div className='flex flex-row items-center gap-x-2'>
                          <BlockButton symbolPretty={Utils.getLogicOperatorPretty('&&')} code="&&" type="logic" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getLogicOperatorPretty('||')} code="||" type="logic" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getLogicOperatorPretty('!')} code="!" type="logic" onClick={handleAddConditionBlock} />
                      </div>
                      {/*
                      <div className='font-semibold font-poppins mt-4'>Comparison Operators</div>
                      <div className='flex flex-row items-center gap-2 flex-wrap'>
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('==')} code="==" type="comparison" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('!=')} code="!=" type="comparison" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('<')} code="<" type="comparison" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('>')} code=">" type="comparison" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('<=')} type="comparison" code="<=" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty={Utils.getComparisonOperatorPretty('>=')} code=">=" type="comparison" onClick={handleAddConditionBlock} />
                      </div>
                       */}
                      <div className='font-semibold text-lg font-poppins mt-4'>Conditions</div>
                      <div className='italic font-poppins'>Datetime</div>
                      <div className='flex flex-row items-center gap-2 flex-wrap'>
                          <BlockButton symbolPretty="Date" code={['{%date%}', '>', {staticValue: dayjs().add(1, 'day').format('YYYY-MM-DD'), urlParam: 'date', useUrlParam: false}]} type="condition.datetime" subtype="date" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty="Time" code={['{%time%}', '>', {staticValue: dayjs().format('YYYY-MM-DD HH:mm'), urlParam: 'time', useUrlParam: false}]} type="condition.datetime" subtype="time" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty="Date & Time" code={['{%datetime%}', '>', {staticValue: dayjs().format('YYYY-MM-DD HH:mm'), urlParam: 'datetime', useUrlParam: false}]} type="condition.datetime" subtype="datetime" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty="Day of week" code={['{%dayOfWeek%}', '==', {staticValue: parseInt(dayjs().format('d')), urlParam: 'dayOfWeek', useUrlParam: false}]} type="condition.datetime" subtype="dayOfWeek" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty="Month" code={['{%month%}', '==', {staticValue: parseInt(dayjs().format('M')), urlParam: 'month', useUrlParam: false}]} type="condition.datetime" subtype="month" onClick={handleAddConditionBlock} />
                      </div>
                      <div className='italic font-poppins mt-4'>URLs</div>
                      <div className='flex flex-row items-center gap-2 flex-wrap w-[440px]'>
                          <BlockButton symbolPretty="URL string parameter" code={['{%url(paramName)%}', '==', '', false]} type="condition.url" subtype="string" onClick={handleAddConditionBlock} />
                          <BlockButton symbolPretty="URL numerical parameter" code={['{%url(paramName)%}', '==', 0]} type="condition.url" subtype="number" onClick={handleAddConditionBlock} />
                      </div>
                  </div>
                </DialogPanel>
              </div>
            </Dialog>
          </>

}

const ConditionBlockDatetime = (props) => {
  const [showOptionsButtons, setShowOptionsButtons] = useState(false)

  //console.log(props.block)

  const getSubtypePretty = (subtype) => {
    switch (subtype) {
      default:
        return subtype[0].toUpperCase() + subtype.slice(1)
    }
  }
  const handleOperatorChange = (operator) => {
    const newCode = [...props.block.code]
    newCode.splice(1,1,operator)
    handleConditionChange('code', newCode)
  }
  const handleConditionChange = (propName, propValue) => {
    const newCondition = {...props.block, [propName]: propValue}
    //console.log(newCondition)
    if (props.onChange) props.onChange(newCondition)
  }
  const handleStaticValueChange = (value) => {
    const newValue = {...props.block.code[2], staticValue: value}
    const newCode = [...props.block.code]
    newCode.splice(2,1,newValue)
    handleConditionChange('code', newCode)
  }
  const handleUrlValueChange = (value) => {
    const newValue = {...props.block.code[2], urlParam: value}
    const newCode = [...props.block.code]
    newCode.splice(2,1,newValue)
    handleConditionChange('code', newCode)
  }
  const handleUseUrlParamChange = (value) => {
    const newValue = {...props.block.code[2], useUrlParam: value}
    const newCode = [...props.block.code]
    newCode.splice(2,1,newValue)
    handleConditionChange('code', newCode)
  }
  const handleDelete = () => {
    if (props.onDelete) props.onDelete(props.block.blockId)
  }
  const renderStaticValue = () => {
    //dayjs always need a full datetime object
    //however when we work with time only we need to use a fake date part with a real time part
    //in this case we want to render only the time part

    switch (props.block.subtype) {
      case "time":
        return new dayjs(props.block.code[2].staticValue).format('HH:mm')
      case "dayOfWeek":
        return new dayjs().day(props.block.code[2].staticValue).format('dddd')
      case "month":
        return new dayjs().month(props.block.code[2].staticValue-1).format('MMMM')
      default:
        return props.block.code[2].staticValue
    }
  }
  const renderMergedValuesInfo = () => {
    switch (props.block.code[0]) {
      case "{%month%}":
        return "Expects numbers between 1 and 12"
      case "{%date%}":
        return "Expects yyyy-MM-dd"
      case "{%datetime%}":
        return "Expects yyyy-MM-dd HH:mm"
      case "{%time%}":
        return "Expects HH:mm or HH:mm:ss"
      case "{%dayOfWeek%}":
        return "Expects numbers between 0 to 6"
      default:
        return ""
    }
  }
 
  if (props.block.editMode) return <div className='bg-white px-2 py-1'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
    
      <div className='flex flex-row items-center gap-x-2'>
        <div>{getSubtypePretty(props.block.subtype)} is</div>
        <div className='w-[230px]'>
          <LionListbox 
            items={Utils.getComparisonOperatorsForListBox()} 
            zIndex={100}
            selectedItemId={props.block.code[1]} 
            onChange={(item) => handleOperatorChange(item.id)}
            />
        </div>
        <div>
          <div className='flex flex-row items-center'>
            <div className='flex flex-row items-center hover:cursor-pointer' onClick={() => {handleUseUrlParamChange(false)}}>
            <Radio
                  checked={!props.block.code[2].useUrlParam}
                  onChange={() => handleUseUrlParamChange(false)}
                  value="useEmailCover"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>Value</div>
            </div>
            <div className='flex flex-row items-center hover:cursor-pointer' onClick={() => {handleUseUrlParamChange(true)}}>
            <Radio
                  checked={props.block.code[2].useUrlParam}
                  onChange={() => handleUseUrlParamChange(true)}
                  value="useEmailCover"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>URL parameter</div>
            </div>

          </div>
          {!props.block.code[2].useUrlParam && <div>
                  {props.block.subtype === 'date' &&
                    <DatePicker
                          value={dayjs(props.block.code[2].staticValue)}
                          format="YYYY-MM-DD"
                          onChange={(val) => handleStaticValueChange(val.format('YYYY-MM-DD'))}
                        />                  
                  }
                  {props.block.subtype === 'time' &&
                    <TimePicker
                          value={dayjs(props.block.code[2].staticValue)}
                          ampm={false}
                          format="HH:mm"
                          onChange={(val) => handleStaticValueChange(val.format('YYYY-MM-DD HH:mm'))}
                        />                  
                  }
                  {props.block.subtype === 'datetime' &&
                    <DateTimePicker
                          value={dayjs(props.block.code[2].staticValue)}
                          ampm={false}
                          format="YYYY-MM-DD HH:mm"
                          onChange={(val) => handleStaticValueChange(val.format('YYYY-MM-DD HH:mm'))}
                        />                  
                  }
                  {props.block.subtype === 'dayOfWeek' &&
                    <div className='w-[190px]'>
                      <LionListbox 
                        items={Utils.getDaysOfWeekForListBox()} 
                        zIndex={100}
                        selectedItemId={props.block.code[2].staticValue}
                        onChange={(item) => handleStaticValueChange(item.id)}
                        />
                    </div>
                  }
                  {props.block.subtype === 'month' &&
                    <div className='w-[190px]'>
                      <LionListbox 
                        items={Utils.getMonthsForListBox()} 
                        zIndex={100}
                        selectedItemId={props.block.code[2].staticValue}
                        onChange={(item) => handleStaticValueChange(item.id)}
                        />
                    </div>
                  }
          </div>}
          {props.block.code[2].useUrlParam && <div>
                <InputText
                        displayName="Parameter name"
                        value={props.block.code[2].urlParam}
                        onChange={(val) => {handleUrlValueChange(val);}}
                />
                {props.checkForErrors && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksValueParamName', props.validationErrorsList.index)
                  && props.block.code[2].urlParam === '' && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                  <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                  {getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksValueParamName', props.validationErrorsList.index)}
                  </div>
                }
                <div className='text-xs'>{renderMergedValuesInfo()}</div>

          </div>}

        </div>
      </div>
      {props.block.subtype === 'dayOfWeek' &&
      <div className='mt-2 px-2 py-1 bg-green-100 rounded text-sm'>
        <Iconify icon={lionIcons.Icon_Alert_Warning} width={28} />
        <div>When using greater/less than, please note we use <span className='font-semibold'>Sunday</span> as the week start</div>
        <div className='flex flex-row gap-x-4 font-semibold'><div>Monday &gt; Sunday</div><div>True</div></div>
        <div className='flex flex-row gap-x-4 font-semibold'><div>Sunday &gt; Monday</div><div>False</div></div>
      </div>
      }
      <div className='mt-2 px-2 py-1 bg-green-100 rounded text-sm'>
        <Iconify icon={lionIcons.Icon_Alert_Warning} width={28} />
        <div>All dates/times are handled as <span className='font-semibold'>UTC</span>(Coordinated Universal Time)</div>
      </div>

      <div className='flex justify-end mt-2'>
        <IconButton onClick={() => handleConditionChange('editMode', false)}>
          <Iconify color={ccColorDarkTeal} icon={lionIcons.Icon_Actions_TickOutlined}/>
        </IconButton>
      </div>
    </LocalizationProvider>

      {props.checkForErrors && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsEditMode', props.validationErrorsList.index) && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
        <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
        {getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsEditMode', props.validationErrorsList.index)}
        </div>
      }

    </div>
  else return <div className='border relative border-ccColorDarkTeal rounded px-6 h-[80px] text-sm flex flex-col items-center justify-center'
                            onMouseEnter={() => setShowOptionsButtons(true)}
                            onMouseLeave={() => setShowOptionsButtons(false)}
              >
      <div className='font-semibold text-ccColorSecondaryGreen'>{props.block.symbolPretty}</div>
      {/*<div>is</div>*/}
      <div className='font-semibold'>{Utils.getComparisonOperatorPretty(props.block.code[1])}</div>
      {!props.block.code[2].useUrlParam && <div className='text-slate-900 font-semibold'>
        {renderStaticValue()}
      </div>
      }
      {props.block.code[2].useUrlParam  && <>
        {props.checkForErrors && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksValueParamName', props.validationErrorsList.index) && props.block.code[2].urlParam === '' ?
        <div className='flex flex-row items-center text-red-500 gap-x-1'>
        <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
          Insert name
        </div>
        :
       <div className='text-slate-900 font-semibold'>
        URL parameter: {props.block.code[2].urlParam}
      </div>
      }
      
      </>
      }
      {showOptionsButtons && <div className='absolute bg-white right-0 top-0 flex flex-col gap-y-1'>
        <div className='p-1 hover:cursor-pointer hover:bg-slate-200' onClick={handleDelete}><Iconify icon={lionIcons.Icon_Actions_Delete} width={22} /></div>
        <div className='p-1 hover:cursor-pointer hover:bg-slate-200' onClick={() => {handleConditionChange('editMode', true); setShowOptionsButtons(false)}}><Iconify icon={lionIcons.Icon_Actions_Edit} width={22} /></div>
        
      </div>

      }
    </div>
}
const ConditionBlockUrl = (props) => {
  const [showOptionsButtons, setShowOptionsButtons] = useState(false)

  //console.log(props.block)

  const handleOperatorChange = (operator) => {
    const newCode = [...props.block.code]
    newCode.splice(1,1,operator)
    handleConditionChange('code', newCode)
  }
  const handleConditionChange = (propName, propValue) => {
    const newCondition = {...props.block, [propName]: propValue}
    //console.log(newCondition)
    if (props.onChange) props.onChange(newCondition)
  }
  const handleParamValueChange = (value) => {
    const newCode = [...props.block.code]
    newCode.splice(2,1,value)
    handleConditionChange('code', newCode)
  }
  const handleParamNameChange = (value) => {
    const newCode = [...props.block.code]
    newCode.splice(0,1,value)
    handleConditionChange('code', newCode)

  }
  const handleParamValueCaseSensitiveChange = (value) => {
    const newCode = [...props.block.code]
    newCode.splice(3,1,value)
    handleConditionChange('code', newCode)
  }
  const handleDelete = () => {
    if (props.onDelete) props.onDelete(props.block.blockId)
  }
  const renderParameterName = () => {
    //we need to remove the {%url()%} part
    const match = props.block.code[0].match(/^\{\%url\((.*?)\)\%\}$/)
    return match ? match[1] : '';
  }
 
  if (props.block.editMode) return <div className='bg-white px-2 py-1'>
      <div className='flex flex-row items-start gap-x-2'>
        <div className='w-[160px]'>
            <InputText
              displayName="Parameter name"
              value={renderParameterName(props.block.code[0])}
              onChange={(val) => {handleParamNameChange(`{%url(${val})%}`);}}
            />
            {props.checkForErrors && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksUrlParamName', props.validationErrorsList.index)
              && props.block.code[0] === '{%url()%}' && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
              <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
              {getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksUrlParamName', props.validationErrorsList.index)}
              </div>
            }
        </div>
        <div className='mt-8'>is</div>
        {props.block.subtype === 'string' &&
          <div className='w-[160px] mt-6'>
            <LionListbox 
              items={Utils.getComparisonOperatorsStringOnlyForListBox()}
              zIndex={100}
              selectedItemId={props.block.code[1]} 
              onChange={(item) => handleOperatorChange(item.id)}
              />
          </div>
        }
        {props.block.subtype === 'number' &&
          <div className='w-[230px] mt-6'>
            <LionListbox 
              items={Utils.getComparisonOperatorsForListBox()}
              zIndex={100}
              selectedItemId={props.block.code[1]} 
              onChange={(item) => handleOperatorChange(item.id)}
              />
          </div>
        }
        {props.block.subtype === 'string' &&
          <div className='w-48 font-poppins'>
            <InputText
              displayName="Value"
              value={props.block.code[2]}
              onChange={(val) => {handleParamValueChange(val);}}
            />
            <div className='flex flex-row items-center -mt-2 -ml-2'>
              <CcCheckbox //displayName=""
                checked={props.block.code[3]}
                onChange={(e) => handleParamValueCaseSensitiveChange(e.target.checked)}
              />
              <div className='text-sm text-ccColorDarkTeal font-poppins'>Case sensitive</div>
            </div>
          </div>
        }
        {props.block.subtype === 'number' &&
          <div className='w-48 font-poppins'>
            <InputNumber displayName="Value"
              min={-1000000} max={1000000} incr={1}
              onChange={(val) => handleParamValueChange(val)}
              value={props.block.code[2]}
            />
          </div>
        }
      </div>
      <div className='flex justify-end mt-2'>
        <IconButton onClick={() => handleConditionChange('editMode', false)}>
          <Iconify color={ccColorDarkTeal} icon={lionIcons.Icon_Actions_TickOutlined}/>
        </IconButton>
      </div>
    </div>
  else return <div className='border relative border-ccColorDarkTeal rounded px-6 h-[80px] text-sm flex flex-col items-center justify-center'
                            onMouseEnter={() => setShowOptionsButtons(true)}
                            onMouseLeave={() => setShowOptionsButtons(false)}
              >
      {props.checkForErrors && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsBlocksUrlParamName', props.validationErrorsList.index)
        && props.block.code[0] === '{%url()%}' ?
        <div className='flex flex-row items-center text-red-500 gap-x-1'>
        <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
        Insert name
        </div>
        :
        <>
          <div className='font-semibold text-ccColorSecondaryGreen'>{props.block.symbolPretty}</div>
          <div className='font-semibold text-ccColorSecondaryGreen'>{renderParameterName(props.block.code[0])}</div>
        </>
      }

      {/*<div>is</div>*/}
      <div className='font-semibold'>{Utils.getComparisonOperatorPretty(props.block.code[1])}</div>
      <div className='text-slate-900 font-semibold'>{props.block.code[2]}</div>

      {showOptionsButtons && <div className='absolute bg-white right-0 top-0 flex flex-col gap-y-1'>
        <div className='p-1 hover:cursor-pointer hover:bg-slate-200' onClick={handleDelete}><Iconify icon={lionIcons.Icon_Actions_Delete} width={22} /></div>
        <div className='p-1 hover:cursor-pointer hover:bg-slate-200' onClick={() => {handleConditionChange('editMode', true); setShowOptionsButtons(false)}}><Iconify icon={lionIcons.Icon_Actions_Edit} width={22} /></div>
        
      </div>

      }
    </div>
}
const ConditionBlockParenthesis = (props) => {
  const [showOptionsButtons, setShowOptionsButtons] = useState(false)
 
  const handleDelete = () => {
    if (props.onDelete) props.onDelete(props.block.blockId)
  }

  return <div className='relative'
              onMouseEnter={() => setShowOptionsButtons(true)}
              onMouseLeave={() => setShowOptionsButtons(false)}
          >
              <div className='bg-white rounded w-16 h-[80px] text-ccColorYellow flex items-center justify-center text-2xl font-semibold'>{props.block.symbolPretty}</div>
              {showOptionsButtons && <div className='absolute -right-1 -top-1 flex flex-col gap-y-1'>
                <div className='p-1 rounded-full hover:cursor-pointer hover:bg-slate-200' onClick={handleDelete}><Iconify icon={lionIcons.Icon_Actions_Delete} width={20} /></div>                
              </div>
              }
            </div>
}
const ConditionBlockLogic = (props) => {
  const [showOptionsButtons, setShowOptionsButtons] = useState(false)
 
  const handleDelete = (e) => {
    e.stopPropagation()
    if (props.onDelete) props.onDelete(props.block.blockId)
  }
  const handleClick = () => {
    const operators = ['&&', '||', '!']
    //we need to go round-robin on the operators array
    const currentIndex = operators.findIndex(op => op === props.block.code)
    let newIndex = currentIndex +1
    if (newIndex >= operators.length) newIndex = 0
    const newOperator = operators[newIndex]

    const newCondition = {...props.block, code: newOperator, symbolPretty: Utils.getLogicOperatorPretty(newOperator)}
    if (props.onChange) props.onChange(newCondition)
  

  }

  return <div className='relative cursor-pointer'
              onMouseEnter={() => setShowOptionsButtons(true)}
              onMouseLeave={() => setShowOptionsButtons(false)}
              onClick={handleClick}
          >
              <div className='bg-white rounded w-16 h-[80px] text-ccColorSecondaryPurple flex items-center justify-center font-semibold text-lg'>{props.block.symbolPretty}</div>
              {showOptionsButtons && <div className='absolute -right-1 -top-1 flex flex-col gap-y-1'>
                <div className='p-1 rounded-full hover:cursor-pointer hover:bg-slate-200' onClick={handleDelete}><Iconify icon={lionIcons.Icon_Actions_Delete} width={20} /></div>                
              </div>
              }
            </div>
}
const ConditionBlockComparison = (props) => {
  const [showOptionsButtons, setShowOptionsButtons] = useState(false)
 
  const handleDelete = () => {
    if (props.onDelete) props.onDelete(props.block.blockId)
  }
  const handleClick = () => {
    const operators = ['==', '!=', '<', '>', '<=', '>=']
    //we need to go round-robin on the operators array
    const currentIndex = operators.findIndex(op => op === props.block.code)
    let newIndex = currentIndex +1
    if (newIndex >= operators.length) newIndex = 0
    const newOperator = operators[newIndex]

    const newCondition = {...props.block, code: newOperator, symbolPretty: Utils.getComparisonOperatorPretty(newOperator)}
    if (props.onChange) props.onChange(newCondition)
  

  }

  return <div className='relative cursor-pointer'
              onMouseEnter={() => setShowOptionsButtons(true)}
              onMouseLeave={() => setShowOptionsButtons(false)}
              onClick={handleClick}
          >
              <div className='bg-white rounded w-fit px-2 h-12 text-ccColorDarkTeal flex items-center justify-center font-semibold'>{props.block.symbolPretty}</div>
              {showOptionsButtons && <div className='absolute -right-1 -top-1 flex flex-col gap-y-1'>
                <div className='p-1 rounded-full hover:cursor-pointer hover:bg-slate-200' onClick={handleDelete}><Iconify icon={lionIcons.Icon_Actions_Delete} width={20} /></div>                
              </div>
              }
            </div>
}

const ActionBuilder = (props) => {
  const [snippets, setSnippets] = useState([])
  const [selectedSnippet, setSelectedSnippet] = useState({})

  useEffect(() => {
    getSnippets()
  }, [])

  useEffect(() => {
    if (props.action?.snippetId) {
      if (snippets.length > 0) {
        setSelectedSnippet(getSnippetInfo(props.action.snippetId))
      }
    }
  }, [props.action?.snippetId, snippets])


  const getSnippets = useCallback(async () => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Snippets`;
      const response = await axios.get(url);

      //console.log(response.data)
      const filteredSnippets = response.data.filter(s => s.snippetTypeId !== 27) //we want to remove conditions manager tags
      setSnippets(filteredSnippets) 

    } catch (error) {
      console.log(error);
    }


  }
  ,[])
  const getSnippetInfo = (id) => {
    const result = snippets.find(s => s.snippetId === id)

    return result
  }

  const handleActionChange = (propName, propValue) => {
    const newAction = {...props.action, [propName]: propValue}

    if (props.onChange) props.onChange(newAction)

  }

  return <div>
          <div className='flex flex-row items-center justify-center gap-x-4'>
            <div className='flex flex-row items-center hover:cursor-pointer' onClick={() => {handleActionChange('type', 'showStatic')}}>
            <Radio
                  checked={props.action?.type === 'showStatic'}
                  onChange={() => handleActionChange('type', 'showStatic')}
                  value="useEmailCover"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>Upload image</div>
            </div>
            <div className='flex flex-row items-center hover:cursor-pointer' onClick={() => {handleActionChange('type', 'showSnippet')}}>
            <Radio
                  checked={props.action?.type === 'showSnippet'}
                  onChange={() => handleActionChange('type', 'showSnippet')}
                  value="useEmailCover"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>Show an Element</div>
            </div>

          </div>
    
          {props.action?.type === 'showStatic' && <div>
            <div className='p-2 flex flex-row items-center gap-x-2'>
              <FileSelector noDeleteButton
                text="Upload image"
                onChange={(val) => handleActionChange('imgB64', val)}
              />
              {props.action?.imgB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[300px] h-[200px] flex flex-col justify-center items-center'>
                    <Iconify icon="carbon:no-image" width={200} />
                    <div className='font-poppins font-semibold'>No image uploaded</div>
                </div>

              }
              {props.action?.imgB64 !== '' &&
                <div className='bg-slate-200 rounded p-4 mt-2 w-[300px] h-[200px] flex justify-center'>
                  <div className='relative h-full' >

                      <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${props.action.imgB64}`} />

                  </div>
                </div>
              }
              {props.showDefaultErrors && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultImage') && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultImage').length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                {getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultImage')}
                </div>
              }
              {props.showActionErrors && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticImage', props.validationErrorsIndex) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticImage', props.validationErrorsIndex).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticImage', props.validationErrorsIndex)}
                </div>
              }

            </div>
            <div className='w-[500px] mb-1'>
              <InputURL
                displayName="Href"
                value={props.action?.href}
                onChange={(val) => {handleActionChange('href', val);}}
                //error={getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsRevealHref', 0)}
                />
            </div>
            {props.showDefaultErrors && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultHref') && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultHref').length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
              <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
              {getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultHref')}
              </div>
            }
            {props.showActionErrors && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticHref', props.validationErrorsIndex) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticHref', props.validationErrorsIndex).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
              <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
              {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsStaticHref', props.validationErrorsIndex)}
              </div>
            }

          </div>
          }
          {props.action?.type === 'showSnippet' && <div>
              <Menu>
                <MenuButton className='border rounded focus:outline-none px-2 py-1 w-72'>
                  {props.action?.snippetId ? <div className='flex flex-row items-center'>
                    {renderCellSnippetType({value: selectedSnippet.snippetTypeId})}
                          <div className='ml-2 font-semibold'>{selectedSnippet.snippetName}</div>
                          <div className='flex grow'></div>
                          <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-500" />          
                      </div>

                  :<div className='flex flex-row items-center'>
                      <div>Select Snippet</div>
                      <div className='flex grow'></div>
                      <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-500" />          
                    </div>}
                </MenuButton>
                <MenuItems anchor="bottom start" className='bg-white focus:outline-none border'>
                  <div className='max-h-64 overflow-auto'>
                    {snippets.map(s => <MenuItem className='hover:bg-slate-100 w-full'>
                      <button className="block py-2 flex flex-row items-center gap-x-1 text-ccColorDarkTeal font-poppins data-focus:bg-blue-100"
                            onClick={() => handleActionChange('snippetId', s.snippetId)} >
                        {renderCellSnippetType({value: s.snippetTypeId})}
                        <div className='flex flex-col items-start text-sm'>
                          <div className='font-semibold'>{s.snippetName}</div>
                          <div>{dayjs(s.created).format('DD/MM/YYYY')}</div>
                        </div>
                      </button>
                    </MenuItem>)
                    }
                  </div>
                </MenuItems>
              </Menu>
              {props.showDefaultErrors && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultSnippetId') && getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultSnippetId').length > 0 && <div className='mt-2 flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                {getErrorMessage(props.validationErrorsList, 'snippetSettingsDefaultSnippetId')}
                </div>
              }
              {props.showActionErrors && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsNoSnippet', props.validationErrorsIndex) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsNoSnippet', props.validationErrorsIndex).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
                <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsActionsNoSnippet', props.validationErrorsIndex)}
                </div>
              }
            </div>
          }
  </div>
}
const getConditionAsTestStr = (blocks) => {
  let stringToEval = ''
  for (const block of blocks) {
    //console.log(block)
    stringToEval += ' '
    switch (block.type) {
      case "logic":
      case "parenthesis":
        stringToEval += block.code
        break
      case "condition.datetime":
        stringToEval += 'true'
        break
      case "condition.url":
        stringToEval += 'true'
        break
      default:
        break
    }
  }
  return stringToEval
}

export  const renderConditionBlockViewOnly = (block) => {
    switch (block.type) {
      case "parenthesis":
        return <ConditionBlockParenthesis block={block} />
      case "logic":
        return <ConditionBlockLogic block={block}
                   />
      case "comparison":
        return <ConditionBlockComparison block={block}
                   />
      default:
        break
    }

    //if we are here the block is of type='condition.xxx'
    //getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsEditMode', props.validationErrorsList.index)

    const conditionType = block.type.split('.')[1]
    switch (conditionType) {
      case "datetime":
        return <ConditionBlockDatetime block={block}
                     />
      case "url":
        return <ConditionBlockUrl block={block}
                      />
      default:
        break

    }

    return <></>

  }


const EvaluatorBuilder = (props) => {
  // EvaluatorBuilder builds conditions and actions for those conditions
  const [syntaxCorrect, setSyntaxCorrect] = useState(true)
  const [showSyntaxCheck, setShowSyntaxCheck] = useState(false)
  const syntaxNodeRef = useRef()

  const handleAddConditionBlock = (block) => {
    const newBlocks = [...props.rule.conditionBlocks]
    newBlocks.push(block)

    const newRule = {...props.rule, conditionBlocks: newBlocks}
    if (props.onChange) props.onChange(newRule)
  }
  const handleConditionBlockChange = (block) => {
    const newBlocks = [...props.rule.conditionBlocks]
    const index = newBlocks.findIndex(b => b.blockId === block.blockId)
    newBlocks.splice(index,1,block)

    const newRule = {...props.rule, conditionBlocks: newBlocks}
    if (props.onChange) props.onChange(newRule)
  }
  const handleConditionBlockDelete = (blockId) => {
    const newBlocks = [...props.rule.conditionBlocks]
    const index = newBlocks.findIndex(b => b.blockId === blockId)
    newBlocks.splice(index,1)

    const newRule = {...props.rule, conditionBlocks: newBlocks}
    if (props.onChange) props.onChange(newRule)
  }

  const renderConditionBlock = (block) => {
    switch (block.type) {
      case "parenthesis":
        return <ConditionBlockParenthesis block={block} onDelete={handleConditionBlockDelete} />
      case "logic":
        return <ConditionBlockLogic block={block}
                  onChange={handleConditionBlockChange}
                  onDelete={handleConditionBlockDelete} />
      case "comparison":
        return <ConditionBlockComparison block={block}
                  onChange={handleConditionBlockChange}
                  onDelete={handleConditionBlockDelete} />
      default:
        break
    }

    //if we are here the block is of type='condition.xxx'
    //getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionsEditMode', props.validationErrorsList.index)

    const conditionType = block.type.split('.')[1]
    switch (conditionType) {
      case "datetime":
        return <ConditionBlockDatetime block={block}
                     onChange={handleConditionBlockChange}
                     onDelete={handleConditionBlockDelete}
                     validationErrorsList={props.validationErrorsList}
                     checkForErrors={props.checkForBlocksErrors} />
      case "url":
        return <ConditionBlockUrl block={block}
                     onChange={handleConditionBlockChange}
                     onDelete={handleConditionBlockDelete}
                     validationErrorsList={props.validationErrorsList}
                     checkForErrors={props.checkForBlocksErrors} />
      default:
        break

    }

    return <></>

  }
  const checkSyntax = () => {
   const stringToEval = getConditionAsTestStr(props.rule.conditionBlocks)
    //once we have the string we need to check the syntax
    try {
        new Function("x", `return (${stringToEval});`);
        setSyntaxCorrect(true)
    } catch {
        setSyntaxCorrect(false)
    }
    setShowSyntaxCheck(true)
    setTimeout(() => setShowSyntaxCheck(false), 2000)
  }
  const handleActionChange = (action) => {

    const newRule = {...props.rule, action: action}
    if (props.onChange) props.onChange(newRule)
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const newBlocks = [...props.rule.conditionBlocks]
    const oldIndex = newBlocks.findIndex(b => b.blockId === active.id)
    const newIndex = newBlocks.findIndex(b => b.blockId === over.id)

    const newRule = {...props.rule, conditionBlocks: arrayMove(newBlocks, oldIndex, newIndex)}
    if (props.onChange) props.onChange(newRule)

  }
function SortableItem({ item }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.blockId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    //padding: "16px",
    //border: "1px solid #ccc",
    //borderRadius: "8px",
    //background: "white",
    //cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style} className=''>
      <div className='h-[16px] flex justify-center'>
          <button
              type="button"
              {...attributes}
              {...listeners}
              className={`cursor-move bg-gray-400 rounded-t-md ${(item.type == 'parenthesis' || item.type == 'logic') ? 'px-6' : 'px-10'}`}
              
            >
              <Iconify icon='fa7-solid:grip' width={16} color='' />
            </button>      

      </div>
      {renderConditionBlock(item)}
    </div>
  );
}


    return <div className='grid grid-cols-2 bg-slate-100 rounded min-w-[400px] min-h-64 text-ccColorDarkTeal font-poppins'>
        <div className=''>
            <div className='text-center font-semibold'>Conditions to match</div>
            {props.rule.conditionBlocks.length === 0 && <div className='flex items-center justify-center'>
              <div className='mt-24'>
                <AddConditionButton onChange={handleAddConditionBlock} />
              </div>
              {getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionBlocks', props.validationErrorsList.index) && getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionBlocks', props.validationErrorsList.index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                  <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />
                  {getErrorMessageForArray(props.validationErrorsList.list, 'snippetSettingsConditionBlocks', props.validationErrorsList.index)}
                  </div>
              }
             </div>}
            {props.rule.conditionBlocks.length > 0 && <div className='text-ccColorDarkTeal font-poppins px-2 py-1'>
               <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                <SortableContext items={props.rule.conditionBlocks.map(b => b.blockId)} strategy={rectSortingStrategy}>
                <div className='flex flex-row items-center flex-wrap gap-2'>
                  {props.rule.conditionBlocks.map((block, index) => {if (block.editMode) return renderConditionBlock(block); else return <SortableItem key={block.blockId} item={block} /> })}
                  <AddConditionButton simple onChange={handleAddConditionBlock} />
                </div>
                {props.showSyntaxError && 
                  <div className='text-center text-red-500 font-semibold'>Syntax error</div>
                }

                <div className='mt-4 flex flex-row items-center gap-x-2'>
                  <CcActionButtonOutlined onClick={checkSyntax}>Check syntax</CcActionButtonOutlined>
          <style>
            {`
              .ccfade-enter {
                opacity: 0;
              }
              .ccfade-enter-active {
                opacity: 1;
                transition: opacity 500ms ease;
              }

              .ccfade-exit {
                opacity: 1;
              }
              .ccfade-exit-active {
                opacity: 0;
                transition: opacity 500ms ease;
              }
            `}
          </style>
                  <CSSTransition
                      in={showSyntaxCheck}
                      timeout={500}
                      classNames="ccfade"
                      unmountOnExit
                      nodeRef={syntaxNodeRef}
                    >
                      <div ref={syntaxNodeRef}>
                        {syntaxCorrect ? 
                        <div className='text-green-400 text-lg'>Syntax OK</div>
                        :
                        <div className='text-red-400 text-lg'>Syntax Error</div>
                        }
                      </div>
                    </CSSTransition>              
                </div>
                </SortableContext>
              </DndContext>
            </div>            
            }
        </div>
        <div>
          <div className='text-center font-semibold'>When matched then</div>
          <ActionBuilder action={props.rule.action}
          validationErrorsList={props.validationErrorsList?.list}
          validationErrorsIndex={props.validationErrorsList?.index}
          showActionErrors
          onChange={handleActionChange} />
        </div>
    </div>
}

export function FlowManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */


  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState(undefined)


  useEffect(() => {
    if (props.snippetInfo) {
      //console.log(props.snippetInfo)
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
    }
    else {
      
    }
  }, [props.templateId, props.snippetInfo])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 27,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;
    result.href = props.snippetInfo.href;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleRuleChange = (index, rule) => {
    const newRules = [...snippetSettings.rules]
    newRules.splice(index,1,rule)
    const newSnippetSettings = {...snippetSettings, rules: newRules}

    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
  }
const handleDefaultChange = (action) => {
  const newSnippetSettings = {...snippetSettings, default: action}

  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}
const handleAddRule = (pos) => {
    const newRules = [...snippetSettings.rules]
    //we want to add the new rule after the 'pos' index
    const newEmptyRule = {conditionBlocks: [], action: {type: 'showStatic', imgB64: '', href: '', snippetId: 0}}
    if (pos === newRules.length -1) newRules.push(newEmptyRule)
    else newRules.splice(pos+1, 0, newEmptyRule)
    const newSnippetSettings = {...snippetSettings, rules: newRules}

    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}
const handleDeleteRule = (pos) => {
    const newRules = [...snippetSettings.rules]
    newRules.splice(pos, 1)
    const newSnippetSettings = {...snippetSettings, rules: newRules}

    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}

const [draggedIndex, setDraggedIndex] = useState(null);
const itemRefs = useRef([]);
function handleDragStart(event, index) {
  setDraggedIndex(index);

  const row = itemRefs.current[index];

  if (row) {
    // Show the full row as the dragged element
    event.dataTransfer.setDragImage(row, 0, 0);
  }
}
function handleDrop(dropIndex) {
  if (draggedIndex === null || draggedIndex === dropIndex) return;

  const newRules = [...snippetSettings.rules]
  const [draggedItem] = newRules.splice(draggedIndex, 1);
  newRules.splice(dropIndex, 0, draggedItem);

  setDraggedIndex(null);
  const newSnippetSettings = {...snippetSettings, rules: newRules}
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}


  return <div className='text-ccColorDarkTeal p-2 flex flex-col'>
            <div className='flex flex-row gap-x-4'>
            <div className="w-96">
                <InputText
                        displayName="Name"
                        value={snippetName}
                        onChange={(val) => {handleSnippetNameChange(val);}}
                        error={getErrorMessage(props.validationErrorsList, 'snippetName')}
                />
            </div>

            <div className="w-96">
                <InputText
                        displayName="Description"
                        value={snippetDesc}
                        onChange={(val) => {handleSnippetDescChange(val);}}
                        error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
                />
            </div>
            </div>

            <div className='mt-4 flex flex-col gap-y-4'>
                {snippetSettings?.rules.map((rule, index) => <div className='relative' ref={(el) => (itemRefs.current[index] = el)}
                                                                  onDragOver={(event) => event.preventDefault()}
                                                                  onDrop={() => handleDrop(index)}>

<div
            draggable
            onDragStart={(event) => handleDragStart(event, index)}
            onDragEnd={() => setDraggedIndex(null)}
            title="Drag to reorder"
            className='absolute top-6 left-2 text-slate-400 cursor-move'>
            <Iconify icon='fa7-solid:grip' width={32} />
          </div>


                    <div className='text-lg font-poppins font-semibold'>Rule {index +1}</div>
                    <div className='flex flex-row items-center'>
                      <div className='grow'>
                        <EvaluatorBuilder rule={rule}
                          onChange={(rule) => handleRuleChange(index, rule)}
                          validationErrorsList={{list: props.validationErrorsList, index: index}}
                          showSyntaxError={props.syntaxErrorList[index]}
                          checkForBlocksErrors={props.checkForBlocksErrors}
                        />
                      </div>
                      {snippetSettings.rules.length > 1 &&
                        <div className='ml-1'>
                          <IconButton onClick={() => handleDeleteRule(index)}><div className='text-ccColorDarkTeal'><Iconify icon={lionIcons.Icon_Actions_Delete} width={32} /></div></IconButton>
                        </div>
                      }

                    </div>
                    <div className='mt-4 ml-12 flex flex-row justify-center items-center text-ccColorDarkTeal'>
                      <Iconify icon="maki:arrow" width={64} rotate={45} />
                      <IconButton onClick={() => handleAddRule(index)}><div className='text-ccColorDarkTeal'><Iconify icon={lionIcons.Icon_Actions_Add} width={44} /></div></IconButton>
                    </div>
                </div>)}
                <div className='bg-slate-100 rounded text-ccColorDarkTeal font-poppins flex flex-col items-center min-h-[330px]'>
                  <div className='font-semibold'>Default</div>
                  <ActionBuilder action={snippetSettings?.default}
                    onChange={handleDefaultChange}
                    showDefaultErrors
                    validationErrorsList={props.validationErrorsList}
                    />

                </div>
            </div>


    </div>

}


export default function ConditionsManagerWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();


    const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', href: '',
                  snippetSettings: {rules: [{conditionBlocks: [], action: {type: 'showStatic', imgB64: '', href: '', snippetId: 0}}], default: {type: 'showStatic', imgB64: '', snippetId: 0}}});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [resetStats, setResetStats] = useState(false); //only used when updating a tag
    const [isEdit, setIsEdit] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
    const [syntaxErrorList, setSyntaxErrorList] = useState([]);
    const [checkForBlocksErrors, setCheckBlocksErrors] = useState(false); //when set to true each block is responsible to check if it has a condition in edit mode and show a message
    

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
        setIsEdit(true)
      }
      else setIsEdit(false)
    }, [props.snippetId])

    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        newSnippetData.snippetSettings = JSON.parse(response.data.snippetSettings);
        //console.log(newSnippetData.snippetSettings)
        //adding new metadata for compatibility with old tags that don't have it
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

  const submitDataSnippet = async () => {

    setShowLoader(true);
    setSuccessHtmlMsg('');
  
    try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/27`;
        if (params.snippetId !== null && params.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/27/${params.snippetId}`;

        const snippetSettingsToPost = {...snippetData.snippetSettings}
        await setRulesHashes(snippetSettingsToPost)

        //console.log(snippetSettingsToPost)
        
        const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetSettingsToPost),
                            }

        const response = await axios.post(url, dataToPost);
  
        setSuccessHtmlMsg(response.data);
        setShowSuccessMsg(true);
    } catch (error) {
      setShowSuccessMsg(false);
      setShowErrorMsg(true);
      console.log(error);
    }
    setShowLoader(false);
    setSubmitted(true)

    return true;
  }
  const setRulesHashes = async (snippetSettings) => {
    const rules = snippetSettings.rules
    for (const rule of rules) {
      let codeStr = ''
      for (const cBlock of rule.conditionBlocks) {
        codeStr += JSON.stringify(cBlock.code)
      }
      const data = new TextEncoder().encode(codeStr);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);

      const hash = [...new Uint8Array(hashBuffer)]
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
      rule.codeStr = codeStr
      rule.codeStrHash = hash
    }
  }

  const handleElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        buildSyntaxErrorList(snippetInfo.snippetSettings.rules)
        snippetDataValidationSchemaConditionsManager.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      setCurrentStep(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {
      let foundErrors
      //apply validation first
      //we can use the same validation of the image optimiser
      try {
        //console.log(snippetData)
        foundErrors = buildSyntaxErrorList()
        snippetDataValidationSchemaConditionsManager.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
        setCheckBlocksErrors(false)
      }
      catch (e) {
        console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setCheckBlocksErrors(true)
        //legacy issue: yup can return also href errors that we don't validate anymore
        // in this step. We need to supress this error here
        const hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'snippetSettingsRevealHref');
        if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
        
        
        //console.log(errorList)
        setActiveErrorList(errorList)
        if (errorList.length > 0) return false;
      }    
      if (foundErrors) return false

      //if we are here then the validastion is passed
      setCurrentStep(navInfo.nextIndex);
      submitDataSnippet()
      
    }
  }
    
  const handleClose = () => {
      navigate("/ph/conditionsManager")
  }
  const buildSyntaxErrorList = (rules) => {
    //validation outside yup
    //we check if the syntax of each rule is correct
    const result = [] //array with correct (true/false) for each rule
    let foundErrors = false
    if (rules == undefined) rules = snippetData.snippetSettings.rules
    for (const rule of rules) {
      const strToEval = getConditionAsTestStr(rule.conditionBlocks)
      try {
          new Function("x", `return (${strToEval});`);
          result.push(false)
      } catch {
          result.push(true)
          foundErrors = true;
      }
    }
    setSyntaxErrorList(result)
    return foundErrors
  }
    

    return <div>
        <CcStepper2
            steps={[{ name: 'Configure', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-gray-200 rounded-md p-2">

            {currentStep === 0 && <FlowManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    syntaxErrorList={syntaxErrorList}
                                    checkForBlocksErrors={checkForBlocksErrors}
                                    snippetInfo={snippetData}
              />}

            {currentStep === 1 && <div className='flex flex-col items-center'>
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <div className='py-12'><CcLoader size={96} /></div> }
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 1 &&
                    <StepperNavButtons totalSteps={2}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}